import React from "react";
import { withRouter } from "react-router-dom";
import withFirebase from "../hoc/withFirebase";
import { Route } from "react-router-dom";
import withUser from "../hoc/withUser";
import SaudaChitti from "../components/SaudaChitti";
class SaudaChittiContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      unitId: null,
      buyer: null,
      seller: null,
      deals: [],
      isLoadingPayment: true,
      isLoadingDispatches: true,
      isLoading: true,
      customers: [],
      units: [],
      products: [],
      organisations: [],
      invoicePrintData: [],
      buyerDetails: [],
      sellerDetails: [],
      currentUser: [],
      customerDetails: []
    };
  }
  componentWillMount() {
    this.fetchSelectedDeal();
    this.fetchCustomerDetails();
    this.fetchOrganisations();
    this.fetchInvoicePrintData();
    this.fetchCurrentUser();
    this.fetchProducts();
    this.fetchUnits();
  }
  fetchInvoicePrintData = () => {
    this.props.db
      .collection("invoicePrintData")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const invoicePrintData = [];
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const invData = doc.data();
            invData.id = doc.id;
            invoicePrintData.push(invData);
          }
        });
        this.setState({ invoicePrintData }, () => {
          console.log(1);
        });
      });
  };
  fetchCustomerDetails = () => {
    this.props.db
      .collection("customers")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const customerDetails = [];
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const singleCustomer = doc.data();
            singleCustomer.id = doc.id;
            customerDetails.push(singleCustomer);
          }
        });
        this.setState({ customerDetails }, () => {
          console.log(1);
        });
      });
  };
  fetchCurrentUser = () => {
    const currentUser = [];
    let currentUserRef = this.props.db
      .collection("users")
      .doc(this.props.user.uid);
    let getDoc = currentUserRef
      .get()
      .then(doc => {
        if (!doc.exists) {
          console.log("No such document!");
        } else {
          const singleUser = doc.data();
          singleUser.id = doc.id;
          currentUser.push(singleUser);
          this.setState({ currentUser }, () => {
            console.log(1);
          });
        }
      })
      .catch(err => {
        console.log("Error getting document", err);
      });
  };
  fetchSelectedDeal = () => {
    this.props.db
      .collection("deals")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const deals = [];
        let buyer = null;
        let seller = null;
        let unitId = null;
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const singleDeal = doc.data();
            singleDeal.id = doc.id;
            deals.push(singleDeal);
            if (doc.id === this.props.match.params.dealId) {
              buyer = doc.data().buyerId;
              seller = doc.data().sellerId;
              unitId = doc.data().unit;
            }
          }
        });
        this.setState({ deals, buyer, seller, unitId }, () => {
          console.log(1);
        });
      });
  };

  fetchUnits = () => {
    this.props.db
      .collection("units")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const units = [];
        querySnapshot.forEach(doc => {
          const singleUnit = doc.data();
          singleUnit.id = doc.id;
          units.push(singleUnit);
        });
        this.setState({ units, isLoading: false }, () => {
          console.log(1);
        });
      });
  };

  fetchProducts = () => {
    this.props.db
      .collection("products")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const products = [];
        querySnapshot.forEach(doc => {
          products.push(doc.data().productName);
        });
        this.setState({ products, isLoading: false }, () => {
          console.log(1);
        });
      });
  };

  fetchOrganisations = () => {
    this.props.db
      .collection("organisations")
      .where("createdBy", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const organisations = [];
        querySnapshot.forEach(doc => {
          const singleOrganisation = doc.data();
          singleOrganisation.organisationId = doc.id;
          organisations.push(singleOrganisation);
        });
        this.setState({ organisations, isLoading: false }, () => {
          console.log(1);
        });
      });
  };
  render() {
    const { user } = this.props;
    const {
      deals,
      isLoadingPayment,
      payments,
      dispatches,
      customers,
      products,
      units,
      transporters,
      currentUser,
      organisations,
      invoicePrintData,
      customerDetails
    } = this.state;

    return (
      <div>
        <Route
          path="/deals/saudaChitti/:dealId"
          render={props => (
            <SaudaChitti
              {...props}
              deals={deals.filter(
                deal => deal.id === this.props.match.params.dealId
              )}
              organisations={organisations.filter(
                org => org.createdBy === this.props.user.uid
              )}
              products={products}
              invoicePrintData={invoicePrintData}
              dealId={this.props.match.params.dealId}
              currentUser={currentUser}
              buyerDetails={customerDetails.filter(
                buyer => buyer.id === this.state.buyer
              )}
              sellerDetails={customerDetails.filter(
                seller => seller.id === this.state.seller
              )}
              units={units.filter(unit => unit.id === this.state.unitId)}
            />
          )}
        />
      </div>
    );
  }
}

export default withRouter(withUser(withFirebase(SaudaChittiContainer)));
